{
  "id": 6,
  "location": "cafe",
  "difficulty": "easy",
  "moves": 10,
  "kinds": 5,
  "goals": [
    { "type": "mud" },
    { "type": "collect", "kind": "donut", "count": 22 }
  ],
  "stars": [2990, 4360],
  "board": [
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . X X . . .",
    ". . . X X . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . ."
  ],
  "calibration": { "runs": 1000, "winRate": 0.978, "movesLeft": 4.1, "closeLosses": 0.015, "target": 0.92 }
}
